import {Box} from "@hosttools/frontend";
import type {ReactNode} from "react";

type Props = {
    children: ReactNode;
};

const Card = ({children}: Props) => {
    return <Box className="border border-blueGray-200 rounded-sm z-auto">{children}</Box>;
};

export default Card;
